// extracted by mini-css-extract-plugin
export var createdDate = "_i8-1";
export var divider = "_i8-2";
export var headerDivider = "_i8-3";
export var messagesCard = "_i8-0";
export var messagesContainer = "_i8-6";
export var messagesContainerWrapper = "_i8-4";
export var showLeftPanelButton = "_i8-8";
export var topButtons = "_i8-7";
export var withPadding = "_i8-5";